import AlipayLightLogo from '../svg/alipay-light.svg';
import AmexLightLogo from '../svg/amex-light.svg';
import ApplePayColorableLogo from '../svg/apple-pay-colorable.svg';
import BankCardFullLogo from '../svg/bank-card-full.svg';
import BankCardLightLogo from '../svg/bank-card-light.svg';
import CirrusLightLogo from '../svg/cirrus-light.svg';
import CitiLightLogo from '../svg/citi-light.svg';
import DinersClubLightLogo from '../svg/diners-club-light.svg';
import GooglePayMonochromeLogo from '../svg/google-pay-monochrome.svg';
import GooglePayLogo from '../svg/google-pay.svg';
import HumoLightLogo from '../svg/humo-light.svg';
import JCBLightLogo from '../svg/jcb-light.svg';
import KlarnaLightLogo from '../svg/klarna-light.svg';
import MaestroLightLogo from '../svg/maestro-light.svg';
import MastercardDarkLogo from '../svg/mastercard-dark.svg';
import MastercardLightLogo from '../svg/mastercard-light.svg';
import MirDarkLogo from '../svg/mir-dark.svg';
import MirLightLogo from '../svg/mir-light.svg';
import MTSPayLightLogo from '../svg/mts-pay-light.svg';
import PayboocLightLogo from '../svg/paybooc-light.svg';
import PayPalLightLogo from '../svg/paypal-light.svg';
import RevolutLightLogo from '../svg/revolut-light.svg';
import SberPayBadgeColorableLogo from '../svg/sber-pay-badge-colorable.svg';
import SberPayBadgeLogo from '../svg/sber-pay-badge.svg';
import SberPayLightLogo from '../svg/sber-pay-light.svg';
import SberPayOutlineColorableLogo from '../svg/sber-pay-outline-colorable.svg';
import SbpColorableLogo from '../svg/sbp-colorable.svg';
import SbpLogo from '../svg/sbp.svg';
import StripeLightLogo from '../svg/stripe-light.svg';
import UnionPayLogo from '../svg/union-pay-light.svg';
import VisaDarkLogo from '../svg/visa-dark.svg';
import VisaLightLogo from '../svg/visa-light.svg';
import VKPayLightLogo from '../svg/vk-pay-light.svg';
import WeChatLightLogo from '../svg/we-chat-light.svg';
import YandexPayLightLogo from '../svg/yandex-pay-light.svg';
import YoomoneyLightLogo from '../svg/yoomoney-light.svg';

export const mapComponentByName = {
  AlipayLight: AlipayLightLogo,
  AmexLight: AmexLightLogo,
  ApplePayColorable: ApplePayColorableLogo,
  BankCardFull: BankCardFullLogo,
  BankCardLight: BankCardLightLogo,
  CirrusLight: CirrusLightLogo,
  CitiLight: CitiLightLogo,
  DinersClubLight: DinersClubLightLogo,
  GooglePayMonochrome: GooglePayMonochromeLogo,
  GooglePay: GooglePayLogo,
  HumoLight: HumoLightLogo,
  JCBLight: JCBLightLogo,
  KlarnaLight: KlarnaLightLogo,
  MaestroLight: MaestroLightLogo,
  MastercardDark: MastercardDarkLogo,
  MastercardLight: MastercardLightLogo,
  MirDark: MirDarkLogo,
  MirLight: MirLightLogo,
  MTSPayLight: MTSPayLightLogo,
  PayboocLight: PayboocLightLogo,
  PayPalLight: PayPalLightLogo,
  RevolutLight: RevolutLightLogo,
  SberPayBadgeColorable: SberPayBadgeColorableLogo,
  SberPayBadge: SberPayBadgeLogo,
  SberPayLight: SberPayLightLogo,
  SberPayOutlineColorable: SberPayOutlineColorableLogo,
  SbpColorable: SbpColorableLogo,
  Sbp: SbpLogo,
  StripeLight: StripeLightLogo,
  UnionPayLight: UnionPayLogo,
  VisaDark: VisaDarkLogo,
  VisaLight: VisaLightLogo,
  VKPayLight: VKPayLightLogo,
  WeChatLight: WeChatLightLogo,
  YandexPayLight: YandexPayLightLogo,
  YoomoneyLight: YoomoneyLightLogo,
} as const;

export type PaymentSystemName = keyof typeof mapComponentByName;
